import { Box, Typography } from '@mui/material';
import { Button } from '@components/button';
import { useGetScreenSize } from '@utils/useGetScreenSize';

interface IMessageNoMatching {
  isConfirmNewCustomerDisabled: boolean;
  onConfirmNewCustomer: () => void;
}

export const MessageNoMatching = ({ isConfirmNewCustomerDisabled, onConfirmNewCustomer }: IMessageNoMatching) => {
  const { isMobileScreen } = useGetScreenSize();
  return (
    <Box
      sx={{
        marginTop: '30px',
        width: isMobileScreen ? '100%' : '500px',
      }}
    >
      <Typography
        variant='bodySmall'
        sx={{
          width: '100%',
          textWrap: 'wrap',
          color: 'white100',
          marginBottom: '24px',
          ml: isMobileScreen ? '0px' : '24px',
        }}
      >
        If the information entered is correct, you can&nbsp;
        <Typography
          variant='bodySmall'
          sx={{
            fontWeight: 'bold',
            display: 'inline',
          }}
        >
          Proceed Using This Name
        </Typography>
        .
      </Typography>
      <Box
        sx={{
          display: 'flex',
          alignContent: 'center',
          justifyContent: 'center',
        }}
      >
        <Button variant='text' disabled={isConfirmNewCustomerDisabled} onClick={onConfirmNewCustomer}>
          Proceed Using This Name
        </Button>
      </Box>
    </Box>
  );
};
